/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FieldOverviewQueryVariables = {|
  eventId: string
|};
export type FieldOverviewQueryResponse = {|
  +whoAmI: ?{|
    +username: string
  |},
  +pgaTourGetDefaultModelForEvent: ?{|
    +id: string
  |},
  +pgaTourEvent: ?{|
    +id: string,
    +tournament: {|
      +officialName: string
    |},
  |},
|};
export type FieldOverviewQuery = {|
  variables: FieldOverviewQueryVariables,
  response: FieldOverviewQueryResponse,
|};
*/


/*
query FieldOverviewQuery(
  $eventId: ID!
) {
  whoAmI {
    username
    id
  }
  pgaTourGetDefaultModelForEvent(eventId: $eventId) {
    id
  }
  pgaTourEvent(eventId: $eventId) {
    id
    tournament {
      officialName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "PGATourModelType",
  "kind": "LinkedField",
  "name": "pgaTourGetDefaultModelForEvent",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FieldOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FieldOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6683cfb3213d9d1a33d69e420ed5d385",
    "id": null,
    "metadata": {},
    "name": "FieldOverviewQuery",
    "operationKind": "query",
    "text": "query FieldOverviewQuery(\n  $eventId: ID!\n) {\n  whoAmI {\n    username\n    id\n  }\n  pgaTourGetDefaultModelForEvent(eventId: $eventId) {\n    id\n  }\n  pgaTourEvent(eventId: $eventId) {\n    id\n    tournament {\n      officialName\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '76ff4bd0084112c2df10d43d17e4d0de';

module.exports = node;
